import {
  ChangeDetectorRef,
  Component,
  effect,
  HostListener,
  inject,
  OnInit,
  Signal,
  signal,
  ViewChild
} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {CardModule} from 'primeng/card';
import {PickListModule, PickListMoveToSourceEvent, PickListSourceSelectEvent} from 'primeng/picklist';
import {CheckboxModule} from 'primeng/checkbox';
import {InputTextModule} from 'primeng/inputtext';
import {ButtonModule} from 'primeng/button';
import {Select, SelectModule} from 'primeng/select';
import {Router} from '@angular/router';
import {StoreDbService} from '../../../core/db/store.db.service';
import {DbStore} from '../../../core/db/models/db-store.model';
import {DeviceService} from '../../../core/services/device.service';
import {RegistroEquipoService} from './services/registro-equipo';
import {Payload} from './interfaces/paisesActivosInterface';
import {PuntoVenta} from './interfaces/puntoVentaActivoInterface';
import {AlertService} from '../../../shared/services/alert.service';
import {ListaRegistroSesionPuntoVenta, RegistrarEquipoInterface} from './interfaces/registrar-equipo-request-interface';
import {RegistrarEquipoResponse, RegistrarEquipoV2Response} from './interfaces/regitrar-equipo-response-interface';
import {AuthSessionState} from '../../../core/auth/auth-session.state';
import {LoginModalAutorice} from '../../../shared/components/login-modal-autorice/login-modal-autorice';
import {ScreenLockService} from '../../../core/services/screen-lock.service';
import {TipoPuntoVentaEnum} from '../../../shared/enums/tipo-punto-venta-enum';
import {SociedadEnum} from '../../../shared/enums/sociedad-enum';
import {AuthService} from '../../../core/auth/auth-service';
import {BackendUser} from '../../../core/interfaces/UserInterface';
import {VirtualScrollerLike} from '../seleccionar-punto-venta/seleccionar-punto-venta';
import {LoadingService} from '../../../shared/components/loading/loading.service';
import {ObtenerEquipoRequest} from './interfaces/obtener-equipo-request-interface';
import {
  obtenerPaisRegistro,
  obtenerSociedadRegistro,
  obtenerTipoPuntoVentaRegistro
} from '../../../shared/constants/corporativos-registro.constant';
import {db} from '../../../core/db/app.db';
import {finalize, Subscription} from 'rxjs';


@Component({
  selector: 'app-registro-equipo',
  imports: [
    CommonModule,
    FormsModule,
    CardModule,
    PickListModule,
    SelectModule,
    CheckboxModule,
    InputTextModule,
    ButtonModule,
    LoginModalAutorice
  ],
  templateUrl: './registro-equipo.html',
  styleUrl: './registro-equipo.scss',
  standalone: true
})
export class RegistroEquipo implements OnInit {
  private alertService = inject(AlertService);
  screenLock = inject(ScreenLockService);
  private cd = inject(ChangeDetectorRef);
  buttonLabel = 'Guardar';
  // PickList
  disponibles = signal<Payload[]>([]);
  seleccionados = signal<Payload[]>([]);
  seleccionado = signal<Payload | null>(null);
  isMobile = signal(false);

  // Select Punto de Venta
  puntosVenta = signal<PuntoVenta[]>([]);
  puntoVentaSeleccionado = signal<PuntoVenta | null>(null);
  listaRegistroSesion = signal<ListaRegistroSesionPuntoVenta[]>([]);
  isReady = signal(false);
  pvDefault = false;
  // Opciones
  multiplesSesiones = true;
  cambiarPV = true;
  nuevaPantalla = true;

  // Impresoras
  printerStore = '';
  printerStoreWeb = false;

  printerZebra = '';
  printerZebraWeb = false;
  printerAlmacen = '';
  deviceId!: string;
  storeExist!: boolean;
  config: DbStore | undefined;
  @ViewChild('pSelect') pSelect!: Select;
  private router = inject(Router);
  private storeDb = inject(StoreDbService);
  private deviceService = inject(DeviceService);
  private registroEquipo = inject(RegistroEquipoService);
  public session = inject(AuthSessionState);
  private auth = inject(AuthService);
  private loadingService = inject(LoadingService);
  private puntosVentaSubscription?: Subscription;
  private seleccionManualEnProceso = false;
  public tipoTienda = TipoPuntoVentaEnum;
  readonly userBackend: Signal<BackendUser | null>;
  errorMessage = '';
  edit = false;

  sociedadPuntoVenta(puntoVenta: string): string {
    return obtenerSociedadRegistro(this.seleccionado()?.pais ?? '', puntoVenta);
  }

  constructor() {
    this.userBackend = this.session.activeRawBackend;
    effect(() => {
      const pais = this.seleccionado()?.pais;
      if (!pais) {
        this.puntosVenta.set([]);
        this.puntoVentaSeleccionado.set(null);
        return;
      }

      if (this.seleccionManualEnProceso) {
        this.seleccionManualEnProceso = false;
        return;
      }

      this.puntoVentaSeleccionado.set(null);
      this.cargarPuntosVenta(pais);
    });
  }

  @HostListener('window:resize')
  onResize() {
    this.checkMobile();
  }

  private checkMobile() {
    if (typeof window !== 'undefined') {
      this.isMobile.set(window.innerWidth <= 768);
    }
  }

  async ngOnInit() {
    this.checkMobile();
    this.storeExist = await this.storeDb.hasStore();
    this.config = await this.storeDb.getConfig();

    // Se comenta porque se requiere login en esta pantalla
    // if(this.config){
      // if (this.config!.tipoPV !== 1) {
        this.screenLock.requestLock('/AdminRegistro','AdminRegistro');
      // }
    // }

    this.loadDevice();
    this.isReady.set(true);
  }

  async loadDevice(){
    this.deviceId = await this.deviceService.getDeviceId()
    const data = {
      pais: this.config?.pais ?? 'SC'
    }
    this.registroEquipo.paisesActivos(data).subscribe({
      next: async (response) => {
        const paisesServicio = response.payload
          .map(pais => {
            const codigo = obtenerPaisRegistro(
              pais.pais || (pais as Payload & {sociedad?: string}).sociedad || ''
            );

            return {
              ...pais,
              pais: codigo,
              descripcion: this.mapearDescripcionPais(codigo, pais.descripcion)
            };
          })
          .filter(pais => Boolean(pais.pais));

        const sociedadSoporte = (await db.sociedad.toArray()).find(
          sociedad => sociedad.sociedad.trim().toUpperCase() === SociedadEnum.SOPORT
        );
        const sociedadesLocales: Payload[] = [{
          pais: SociedadEnum.SOPORT,
          descripcion: sociedadSoporte?.descripcion || 'SOPORTE',
          esSociedad: true,
          paisActivo: true
        }];

        const paises = [...paisesServicio, ...sociedadesLocales]
          .filter((pais, index, items) =>
            items.findIndex(item => item.pais === pais.pais) === index
          );

        this.disponibles.set(paises);

        if (this.storeExist) {
          this.buttonLabel = 'Modificar';
          this.edit = true;
          this.cargarEquipoGuardado();
        } else {
          console.log('no hay tienda');
          const cvePais = 'SC';
          console.log(cvePais);
          const paisSC = this.disponibles().find(p => p.pais === cvePais);
          console.log(paisSC)
          if (paisSC) {
            this.seleccionado.set(paisSC);
            this.seleccionados.set([paisSC]);
            this.disponibles.set(
              this.disponibles().filter(p => p !== paisSC)
            );
          }
        }

      },
      error: err => console.error('Error en logout', err)
    });
  }

  private cargarEquipoGuardado() {
    const data: ObtenerEquipoRequest = {payload: {
        fingerWeb: this.deviceId
      }};
    this.registroEquipo.obtenerEquipo(data).subscribe({
      next: async (response) => {
        const lista = response.payload?.listaRegistroSesionPuntoVenta;
        if (!lista?.length) return;

        const paisGuardado = obtenerPaisRegistro(this.config?.pais ?? '');
        const registroOriginal: ListaRegistroSesionPuntoVenta = {
          default: 0,
          puntoVenta: response.payload.pvOriginal.puntoVenta,
          tipoPuntoVenta: response.payload.pvOriginal.tipoPuntoVenta,
          id: {
            pais: obtenerPaisRegistro(response.payload.paisOriginal)
          }
        };
        const registroDefault = lista.find(x => x.default === 1) ??
          lista.find(x =>
            x.id.pais === paisGuardado &&
            x.puntoVenta === this.config?.puntoVenta
          ) ??
          registroOriginal;
        const listaPantalla = lista.some(x =>
          x.id.pais === registroDefault.id.pais &&
          x.puntoVenta === registroDefault.puntoVenta
        )
          ? lista
          : [registroDefault, ...lista];

        const paisesBackend = listaPantalla.map(x => x.id.pais);

        const paisesSeleccionados = this.disponibles()
          .filter(p => paisesBackend.includes(p.pais));

        this.seleccionados.set(paisesSeleccionados);

        this.disponibles.set(
          this.disponibles()
            .filter(p => !paisesBackend.includes(p.pais))
        );

        this.listaRegistroSesion.set(listaPantalla);

        if (registroDefault) {
          const paisDefault = paisesSeleccionados
            .find(p => p.pais === registroDefault.id.pais);

          if (paisDefault) {
            this.seleccionado.set(paisDefault);
          }
        }
      },
      error: err => {
        console.error('Error en logout', err);
      }
    });
  }

  clean(): void {
    // this.ngOnInit();
    this.pvDefault = false;
    this.multiplesSesiones = true;
    this.cambiarPV = true;
    this.nuevaPantalla = true;
    this.printerStore = '';
    this.printerStoreWeb = false;

    this.printerZebra = '';
    this.printerZebraWeb = false;
    this.printerAlmacen = '';
    this.loadDevice();
  }

  onChange() {
    const seleccionado = this.puntoVentaSeleccionado();
    if (!seleccionado) return;
    const paisActual = this.seleccionado()!.pais;

    this.listaRegistroSesion.update((listaActual) => {

      const index = listaActual.findIndex(
        x => x.id.pais === paisActual
      );

      const nuevoRegistro: ListaRegistroSesionPuntoVenta = {
        default: 0,
        puntoVenta: seleccionado.puntoVenta,
        tipoPuntoVenta: seleccionado.tipoPuntoVenta,
        id: {
          pais: paisActual
        }
      };

      if (index !== -1) {
        const copia = [...listaActual];
        copia[index] = nuevoRegistro;
        return copia;
      }

      return [...listaActual, nuevoRegistro];
    });

    console.log('Lista actualizada:', this.listaRegistroSesion());
  }

  async save(): Promise<void>{
    if(this.pvDefault && this.puntoVentaSeleccionado()?.puntoVenta) {
      this.loadingService.show();
      this.fillDefault();
      const data: RegistrarEquipoInterface = this.fillData();
      this.registroEquipo.registrarEquipo(data).subscribe({
        next: async (response) => {
          if(response?.exception){
            this.errorMessage = this.extractErrorMessage(response.exception)
            this.loadingService.hide();
            await this.alertService.error('Error al guardar', this.errorMessage);
            return;
          }
          const dataStore = this.transformData(response.payload);
          await this.storeDb.saveStore(dataStore);
          this.loadingService.hide();
          const dialog = await this.alertService.success('Guardado Correctamente', 'Dispositivo registrado exitosamente');
          if(dialog) {
            this.nav(true);
          }

        },
        error: async err => {
          console.error('Error en logout', err);
          this.loadingService.hide();
          await this.alertService.warn('Error', `Ocurrio un error al enviar los datos del equipo, verifica tu conexión o intentalo mas tarde.`);
        }
      });
    } else {
      this.loadingService.hide();
      await this.alertService.warn('Validación','Debes elegir un Punto de Venta y seleccionarlo como predeterminado');
    }

  }

  async update(): Promise<void>{
    if(this.pvDefault && this.puntoVentaSeleccionado()?.puntoVenta) {
      this.loadingService.show();
      this.fillDefault();
      const data: RegistrarEquipoInterface = this.fillData();
      this.registroEquipo.actualizarEquipo(data).subscribe({
        next: async (response) => {
          if(response?.exception){
            this.errorMessage = this.extractErrorMessage(response.exception)
            this.loadingService.hide();
            await this.alertService.error('Error al guardar', this.errorMessage);
            return;
          }
          const dataStore = this.transformData(response.payload);
          await this.storeDb.saveStore(dataStore);
          this.loadingService.hide();
          const dialog = await this.alertService.success('Actualizado Correctamente', 'Dispositivo registrado exitosamente');
          if(dialog){
            this.logout();
          }

        },
        error: async err => {
          console.error('Error', err);
          this.loadingService.hide();
          await this.alertService.warn('Error', `Ocurrio un error al enviar los datos del equipo, verifica tu conexión o intentalo mas tarde.`);
        }
      });
    } else {
      await this.alertService.warn('Validación','Debes elegir un Punto de Venta y seleccionarlo como predeterminado');
    }
  }

  fillDefault():void {
    const paisActual = this.seleccionado()!.pais;
    const pvSeleccionado = this.puntoVentaSeleccionado()!.puntoVenta;

    this.listaRegistroSesion.update(listaActual =>

      listaActual.map(item => ({
        ...item,
        default:
          item.id.pais === paisActual &&
          item.puntoVenta === pvSeleccionado
            ? 1
            : 0
      }))

    );
  }

  fillData(): RegistrarEquipoInterface {
    return {
        pais: this.seleccionado()!.pais,
        payload: {
        impresoraTienda: this.printerStore,
        tipoVenta: this.puntoVentaSeleccionado()!.tipoPuntoVenta,
        impresoraAlmacen: this.printerAlmacen,
        sesionMultiple: Number(this.multiplesSesiones),
        impresoraZebra: this.printerZebra,
        cambiarPV: Number(this.cambiarPV),
        pvOriginal: this.puntoVentaSeleccionado()!.puntoVenta,
        nev: 1, // va fijo por el momento
        fingerWeb: this.deviceId,
        paisOriginal: this.seleccionado()!.pais,
        impresionWEBTienda: Number(this.printerStoreWeb),
        impresionWEBZebra: Number(this.printerZebraWeb),
        default: Number(this.pvDefault),
        listaRegistroSesionPuntoVenta: this.listaRegistroSesion()
    },
      puntoVenta: this.puntoVentaSeleccionado()!.puntoVenta,
        usuario: this.session.usuario() || 'UBATCH'
    }
  }

  nav(skipConfirm: boolean): void {
    this.router.navigateByUrl('/login', { replaceUrl: true , state: {skipConfirm}})
  }

  onTargetSelect(event: PickListSourceSelectEvent) {
    const item = event.items?.[0] ?? null;
    if (!item) return;

    this.seleccionManualEnProceso = this.seleccionado() !== item;
    this.seleccionado.set(item);
    this.puntoVentaSeleccionado.set(null);
    this.cargarPuntosVenta(item.pais, true);
  }

  onMoveToSource(event: PickListMoveToSourceEvent) {
    const itemsRemovidos: Payload[] = event.items;

    if (!itemsRemovidos?.length) return;

    const paisesRemovidos = itemsRemovidos.map(p => p.pais);

    this.listaRegistroSesion.update(lista =>
      lista.filter(item => !paisesRemovidos.includes(item.id.pais))
    );

    const paisActual = this.seleccionado()?.pais;

    if (paisActual && paisesRemovidos.includes(paisActual)) {
      this.seleccionado.set(null);
      this.puntoVentaSeleccionado.set(null);
      this.puntosVenta.set([]);
    }

    console.log('Lista actualizada:', this.listaRegistroSesion());
  }

  cargarPuntosVenta(pais: string, mostrarLoader = false) {
    this.puntosVentaSubscription?.unsubscribe();

    if (pais.trim().toUpperCase() === 'SOPORT') {
      const puntoVentaDefault = this.crearPuntoVentaCorporativoDefault();
      this.puntosVenta.set([puntoVentaDefault]);
      this.puntoVentaSeleccionado.set(puntoVentaDefault);
      this.pvDefault = true;
      this.onChange();
      return;
    }

    if (mostrarLoader) {
      this.loadingService.show('Cargando puntos de venta...');
    }
    this.puntosVentaSubscription = this.registroEquipo
      .puntosVentaActivos({ pais })
      .pipe(finalize(() => {
        if (mostrarLoader) {
          this.loadingService.hide();
        }
      }))
      .subscribe({
      next: (response) => {
        const puntosVenta = response.payload?.length
          ? response.payload
          : [this.crearPuntoVentaCorporativoDefault()];

        this.puntosVenta.set(puntosVenta);

        if (!this.storeExist) return;

        const sel = this.seleccionado();
        if (!sel) return;

        const registroDefault = this.listaRegistroSesion()
          .find(x => x.id.pais === sel.pais);

        if (!registroDefault) return;

        const puntoVenta = puntosVenta
          .find(p => p.puntoVenta === registroDefault.puntoVenta);

        if (puntoVenta) {
          this.puntoVentaSeleccionado.set(puntoVenta);
          this.pvDefault = true;
        }

      },
      error: err => {
        console.error('Error obteniendo puntos de venta', err);
        this.puntosVenta.set([this.crearPuntoVentaCorporativoDefault()]);
      }
    });
  }

  private crearPuntoVentaCorporativoDefault(): PuntoVenta {
    return {
      puntoVenta: 'F000',
      descripcion: 'CORPORATIVO',
      tipoPuntoVenta: TipoPuntoVentaEnum.Corporativo,
      activo: 1,
      razonSocial: {
        SRazonSocial: 'CORPORATIVO',
        abreviatura: ''
      }
    };
  }

  private mapearDescripcionPais(codigo: string, descripcion: string): string {

    // reglas por país
    const reglasPorPais: Record<string, string> = {
      'SC': 'SUPRACARE',
      'VU': 'Vipaigua México',
      'MX': 'México FRAICHE'
    };

    // si existe regla, se usa
    if (reglasPorPais[codigo]) {
      return reglasPorPais[codigo];
    }

    return descripcion;
  }

  transformData(data: RegistrarEquipoResponse | RegistrarEquipoV2Response): DbStore {
    const paisSeleccionado = this.seleccionado()!.pais;
    const puntoVentaSeleccionado = this.puntoVentaSeleccionado()!.puntoVenta;
    const sociedad = obtenerSociedadRegistro(paisSeleccionado, puntoVentaSeleccionado);
    const sociedadOriginal = obtenerSociedadRegistro(paisSeleccionado, data.puntoVentaOriginal);

    return  {
      tipoPV: obtenerTipoPuntoVentaRegistro(puntoVentaSeleccionado, data.tipoPV),
      fingerWeb: data.fingerWeb,
      impresoraAlmacen: data.impresoraAlmacen,
      impresoraTienda: data.impresoraTienda,
      impresoraZebra: data.impresoraZebra,
      nev: data.nev,
      paisOriginal: sociedadOriginal,
      puntoVentaOriginal: data.puntoVentaOriginal,
      registro: data.registro,
      cambiarPV: this.cambiarPV,
      key: 'store-id',
      sesionMultiple: this.multiplesSesiones,
      nuevaPantalla: this.nuevaPantalla,
      pais: sociedad,
      descripcionPais: this.seleccionado()!.descripcion,
      esSociedad: this.seleccionado()!.esSociedad,
      paisActivo: this.seleccionado()!.paisActivo,
      activo: this.puntoVentaSeleccionado()!.activo,
      descripcionPuntoVenta: this.puntoVentaSeleccionado()!.descripcion,
      descripcionPuntoOriginal: this.puntoVentaSeleccionado()!.descripcion,
      puntoVenta: puntoVentaSeleccionado,
      value: this.deviceId,
      pvDefault: this.pvDefault,
      razonSocial: this.puntoVentaSeleccionado()!.razonSocial.SRazonSocial,
      imagenFondo: this.puntoVentaSeleccionado()!.razonSocial.abreviatura
    }
  }
  private extractErrorMessage(error: unknown): string {
    console.log(error);

    if (error instanceof Error) {
      return error.message;
    }

    if (typeof error === 'string') {
      return error;
    }

    if (
      typeof error === 'object' &&
      error !== null &&
      'message' in error &&
      typeof (error as { message?: unknown }).message === 'string'
    ) {
      return (error as { message: string }).message;
    }

    return 'Error inesperado';
  }

  logout() {
    this.auth.logout().subscribe({
      next: () => this.nav(true),
      error: err => console.error('Error en logout', err)
    });
  }

  onShowPvSelect() {
    setTimeout(() => {
      if (this.pSelect && this.pSelect.scroller) {
        // Obtener el índice del registro seleccionado
        const valorActual = this.puntoVentaSeleccionado();
        const index = this.puntosVenta().findIndex(
          p => p.puntoVenta === valorActual?.puntoVenta
        );

        if (index > -1) {
          // FORZAR EL SCROLL
          const scroller = this.pSelect.scroller  as unknown as VirtualScrollerLike;

          // Limpiar caché de renderizado
          if (scroller.clearCache) {
            scroller.clearCache();
          }

          if (scroller.handleScroll) {
            scroller.handleScroll();
          }

          // Re-posicionar
          scroller.scrollToIndex(0);
          scroller.scrollToIndex(index);

          // Forzar detección de cambios del componente
          this.cd.detectChanges();
        } else {
          this.pSelect.scroller.scrollToIndex(0);
        }
      }
    }, 100);

  }

}
